<template>
  <FaIcon :icon="['fas', GROUP_DEFAULT_ICON]" />
</template>

<script setup lang="ts">
import { GROUP_DEFAULT_ICON } from '@/config/group';
</script>
